import { PayloadAction, createSlice } from '@reduxjs/toolkit'
import { OriginalRootState } from 'redux/rootReducer'

export interface AppInfoState {
  isAppInfoModalOpen?: boolean
  isUserLoggedIn?: boolean
  isParentAccount?: boolean
  isSessionStarted?: boolean
  isCardReissueModalOpen?: boolean
  error?: boolean
  errorMessage?: string
  isSessionExpired?: boolean
}

export const initState: AppInfoState = {
  isAppInfoModalOpen: false,
  isUserLoggedIn: false,
  isParentAccount: true,
  isSessionStarted: false,
  isCardReissueModalOpen: true,
  error: false,
  errorMessage: '',
  isSessionExpired: false
}

export const appInfoSlice = createSlice({
  name: 'appInfoSlice',
  initialState: initState,
  reducers: {
    updateAppInfoState: (
      state: AppInfoState,
      action: PayloadAction<AppInfoState>
    ) => {
      return {
        ...state,
        ...action.payload
      }
    },
    showWelcomeMat(state) {
      state.isAppInfoModalOpen = true
    },
    hideWelcomeMat(state) {
      state.isAppInfoModalOpen = false
    },
    logInUser(state) {
      state.isUserLoggedIn = true
    },
    hideCardReissueModal(state) {
      state.isCardReissueModalOpen = false
    }
  }
})

export const selectIsUserLoggedIn = (state: OriginalRootState) =>
  state.appInfo.isUserLoggedIn

export const selectIsAppInfoModalOpen = (state: OriginalRootState) =>
  state.appInfo.isAppInfoModalOpen

export const selectIsCardReissueModalOpen = (state: OriginalRootState) =>
  state.appInfo.isCardReissueModalOpen

export const {
  updateAppInfoState,
  hideWelcomeMat,
  logInUser,
  showWelcomeMat,
  hideCardReissueModal
} = appInfoSlice.actions

export default appInfoSlice.reducer
